angular.module('impactx.smartform').directive('ixSmartFormTitle', function () {
    return {
        restrict: 'E',
        require: ['?^form'],
        scope: {
            config: "=",
            editable: "=",
            smartFormTitle: "=",
            hideTitle: "="
        },
        controller: 'SmartFormTitleCtrl',
        templateUrl: 'shared/smartform/templates/smart-form-title.tmpl.html',
        link: function (scope, element, attrs, formCtrl) {
            scope.formCtrl = formCtrl[0];
        }
    }
});